<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'GraficoBarraVendedoresPequeno',
  extends: Bar,
  props: {
    data:   { type: Array,  required: true },
    labels: { type: Array,  required: true },
    height: { type: Number, default: 40 },
  },
  methods: {
    montarGrafico () {
      this.renderChart(
        { labels: this.labels, datasets: this.data },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {                 // tooltip mostra nome + valor
            mode: 'index', intersect: false,
            callbacks: {
              title: items => this.labels[items[0].index], // vendedor
              label: (it, data) => {
                const ds = data.datasets[it.datasetIndex]
                const val = Number(it.yLabel || it.value || 0)
                return `${ds.label || ''} ${val.toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}`
              }
            }
          },
          scales: {                   // SEM eixos/labels
            xAxes: [{ display: false, categoryPercentage: 1, barPercentage: 0.5 }],
            yAxes: [{ display: false }]
          }
        }
      )
    }
  },
  mounted () { this.montarGrafico() },
  watch: {
    labels () { this.montarGrafico() },
    data   () { this.montarGrafico() }
  },
  beforeDestroy () { if (this._chart?.destroy) this._chart.destroy() }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/vendas/GraficoBarraVendedoresPequeno.vue